<template>
  <van-config-provider style="height:100vh;" :theme-vars="themeVars">
    <Frame class="page-frame">
      <template v-slot:header>
        <CustomHeader
          v-if="hasNavHeader"
          :left-arrow="true"
          left-text="申请访客"
          :theme-vars="themeVars"
        />
      </template>
      <template v-slot:body>
        <div class="body">
          <van-cell-group inset>
            <van-field
              v-model="form.appointmentDictionaryName"
              name="访问类型"
              label="访问类型"
              placeholder="请选择"
              input-align="right"
              required
              is-link
              readonly
              @click="showPickerVisitorType = true"
            />
            <van-field
              v-if="userType !== 'teacher'"
              v-model="form.intervieweeName"
              name="拜访对象"
              label="拜访对象"
              placeholder="拜访对象"
              input-align="right"
              required
              is-link
              readonly
              @click="showPickerIntervieweeEvt"
            />
            <van-field
              v-if="userType !== 'teacher'"
              v-model="form.intervieweePhone"
              name="拜访对象手机号"
              label="拜访对象手机号"
              placeholder="拜访对象手机号"
              input-align="right"
              required
            />
            <van-field
              v-model="form.applicationDate"
              name="预约拜访时间"
              label="预约拜访时间"
              placeholder="预约拜访时间"
              input-align="right"
              required
              is-link
              readonly
              @click="showPickerApplicationDate = true"
            />
          </van-cell-group>

          <van-cell-group inset>
            <van-field
              v-model="form.personName"
              name="访客姓名"
              label="访客姓名"
              placeholder="请输入"
              input-align="right"
              required
              :disabled="
                plateformType == 'DingTalkMini' && userType !== 'teacher'
              "
            />
            <van-field
              v-model="form.phone"
              name="访客手机号"
              label="访客手机号"
              placeholder="请输入"
              input-align="right"
              required
            />
            <van-field
              name="访客性别"
              label="访客性别"
              placeholder="请选择"
              input-align="right"
              border
            >
              <template #input>
                <van-radio-group v-model="form.sex" direction="horizontal">
                  <van-radio name="man">
                    <template #icon="props">
                      <van-image
                        class="img-icon"
                        width="18px"
                        height="18px"
                        :src="
                          props.checked
                            ? require('@/assets/image/common/checked.png')
                            : require('@/assets/image/common/un_checked.png')
                        "
                      />
                    </template>
                    男
                  </van-radio>
                  <van-radio name="girl">
                    <template #icon="props">
                      <van-image
                        class="img-icon"
                        width="18px"
                        height="18px"
                        :src="
                          props.checked
                            ? require('@/assets/image/common/checked.png')
                            : require('@/assets/image/common/un_checked.png')
                        "
                      />
                    </template>
                    女
                  </van-radio>
                </van-radio-group>
              </template>
            </van-field>

            <van-field
              v-model="form.idNumber"
              input-align="right"
              name="访客身份证号"
              label="访客身份证号"
              placeholder="请输入"
            />
            <!-- <van-field
              v-if="customFormField[3].isHas"
              :required="customFormField[3].require"
              v-model="form.idNumber"
              input-align="right"
              name="访客身份证号"
              label="访客身份证号"
              placeholder="请输入"
            /> -->

            <van-field
              v-if="customFormField[2].isHas"
              :required="customFormField[2].require"
              v-model="form.faceUrl"
              name="访客人脸"
              label="访客人脸"
              placeholder="访客人脸"
              input-align="right"
              border
            >
              <template #input>
                <DDFaceUploader
                  v-if="
                    plateformType == 'DingTalkMini' && userType !== 'teacher'
                  "
                  :school-code="schoolCode"
                  :module-name="visitor"
                  :default-file-List="form.faceFileList"
                  @upload="faceFileUpload"
                  @clear="faceFileClear"
                />
                <JyUploader
                  v-else
                  class="jy-uploader"
                  capture="user"
                  :school-code="schoolCode"
                  :is-face-check="true"
                  :module-name="visitor"
                  :default-file-List="form.faceFileList"
                  @upload="faceFileUpload"
                />
              </template>
            </van-field>
          </van-cell-group>

          <van-cell-group
            inset
            v-if="customFormField[7].isHas || customFormField[8].isHas"
          >
            <van-field
              v-if="customFormField[7].isHas"
              :required="customFormField[7].require"
              v-model="form.healthCodeUrl"
              name="访客健康码"
              label="访客健康码"
              placeholder="请选择"
              input-align="right"
              border
            >
              <template #input>
                <JyUploader
                  class="jy-uploader"
                  :school-code="schoolCode"
                  :module-name="visitor"
                  :default-file-List="form.healthCodeFileList"
                  @upload="healthFileUpload"
                />
              </template>
            </van-field>

            <van-field
              v-if="customFormField[8].isHas"
              :required="customFormField[8].require"
              v-model="form.travelCodeUrl"
              name="访客行程码"
              label="访客行程码"
              placeholder="请选择"
              input-align="right"
              border
            >
              <template #input>
                <JyUploader
                  class="jy-uploader"
                  :school-code="schoolCode"
                  :module-name="visitor"
                  :default-file-List="form.travelCodeFileList"
                  @upload="travelFileUpload"
                />
              </template>
            </van-field>
          </van-cell-group>

          <van-cell-group
            inset
            v-if="customFormField[5].isHas || customFormField[4].isHas"
          >
            <van-field
              v-if="customFormField[5].isHas"
              :required="customFormField[5].require"
              v-model="form.peopleSum"
              name="访客同行人数"
              label="访客同行人数"
              placeholder="请输入"
              input-align="right"
            />
            <van-field
              v-if="customFormField[4].isHas"
              :required="customFormField[4].require"
              v-model="form.carCode"
              name="访客车牌信息"
              label="访客车牌信息"
              placeholder="请输入"
              input-align="right"
            />
          </van-cell-group>

          <van-cell-group inset>
            <van-field
              v-show="customFormField[6].isHas"
              :required="customFormField[6].require"
              v-model="form.remark"
              rows="3"
              autosize
              label=""
              type="textarea"
              maxlength="200"
              :placeholder="
                customFormField[6].require
                  ? '请输入访问事由(必填)...'
                  : '请输入访问事由...'
              "
              show-word-limit
            />
          </van-cell-group>
        </div>
      </template>
      <template v-slot:footer>
        <div class="footer">
          <van-button class="van-button" type="primary" @click="submit"
            >提交</van-button
          >
        </div>
      </template>
    </Frame>

    <van-popup v-model:show="showPickerApplicationDate" position="bottom">
      <van-picker
        title="拜访时间"
        :columns="dateTimeColumns"
        @confirm="onConfirmApplicationDate"
        @cancel="onCancleApplicationDate"
      />
    </van-popup>
    <van-popup v-model:show="showPickerVisitorType" position="bottom">
      <div class="visitor-type">
        <div class="header">
          <div class="left"></div>
          <div class="middle title">访问类型</div>
          <div class="right control" @click="showPickerVisitorType = false">
            取消
          </div>
        </div>
        <van-radio-group v-model="form.appointmentDictionaryCode">
          <van-cell-group inset>
            <van-cell
              :title="item.name"
              clickable
              :key="item.code"
              v-for="item in visitorTypeList"
              @click="appointmentDictionaryChange(item)"
            >
              <template #right-icon>
                <van-radio :name="item.code">
                  <template #icon="props">
                    <van-image
                      class="img-icon"
                      width="18px"
                      height="18px"
                      :src="
                        props.checked
                          ? require('@/assets/image/common/checked.png')
                          : require('@/assets/image/common/un_checked.png')
                      "
                    />
                  </template>
                </van-radio>
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </van-popup>
  </van-config-provider>
</template>

<script>
import Frame from "@/components/frame.vue"
import CustomHeader from "@/components/customHeader/index.vue"
import JyUploader from "./components/jyUploader.vue"
import DDFaceUploader from "./components/ddFaceUploader.vue"

import Time from "@/utils/time.js"
import { mobileValide, idCardValide } from "@/utils/valide.js"
import { Toast } from "vant"
import { ref, reactive, computed, toRaw, watch } from "vue"
import { useStore } from "vuex"
import { useRouter } from "vue-router"
export default {
  name: "VisitorApply",
  components: {
    Frame,
    CustomHeader,
    JyUploader,
    DDFaceUploader,
  },
  setup() {
    const themeVars = {
      navBarTextColor: "#333",
      navBarTextSize: "44px",
      cellGroupInsetPadding: "10px 0px",
      cellGroupInsetBorderRadius: 0,
      fieldLabelWidth: "150px",
      fieldWordLimitLineHeight: "36px",
      uploaderSize: "32px",
      uploaderIconSize: "20px",
      cellLineHeight: "54px",
      cellVerticalPadding: "0px",
      cellHorizontalPadding: "16px",
      popupBackgroundColor: "transparent",
    }
    const store = useStore()
    const router = useRouter()

    const BASE_FILE_URL = process.env.VUE_APP_BASE_File_URL

    const schoolCode = computed(() => store.state.schoolCode)
    const hasNavHeader = computed(() => store.getters.hasNavHeader)
    const plateformType = computed(() => store.getters.plateformType)
    const userType = computed(() => store.state.userType)
    const phone = computed(() => store.state.phone)
    const userName = computed(() => store.state.userName)
    const idNumber = computed(() => store.state.idNumber)
    const form = computed({
      get: () => store.state.visitor.applyForm,
      set: (payload) => store.commit("visitor/setApplyForm", payload),
    })
    // const form = ref({ ...store.state.visitor.applyForm })

    if (userType.value !== "teacher") {
      if (phone.value) {
        form.value.phone = phone.value
      }
      if (userName.value) {
        form.value.personName = userName.value
      }
      if (idNumber.value) {
        form.value.idNumber = idNumber.value
      }
    }

    // 用户自定义字段配置
    let customFormField = ref({
      2: {
        id: 2,
        code: "FACE",
        name: "人脸",
        isHas: false,
        require: false,
      },
      3: {
        id: 3,
        code: "CERTIFICATES",
        name: "证件信息",
        isHas: false,
        require: false,
      },
      4: {
        id: 4,
        code: "CAR",
        name: "车辆信息",
        isHas: false,
        require: false,
      },
      5: {
        id: 5,
        code: "PEOPLE_NUMBER",
        name: "同行人数",
        isHas: false,
        require: false,
      },
      6: {
        id: 6,
        code: "MATTER",
        name: "来访事由",
        isHas: false,
        require: false,
      },
      7: {
        id: 7,
        code: "HEALTH_CODE",
        name: "健康码",
        isHas: false,
        require: false,
      },
      8: {
        id: 8,
        code: "TRAVEL_CODE",
        name: "行程码",
        isHas: false,
        require: false,
      },
    })
    const openConfInfo = (params) =>
      store.dispatch("visitor/openConfInfo", params)
    const getpenConfInfo = async () => {
      let params = {
        schoolCode: schoolCode.value,
      }
      let r = await openConfInfo(params)
      if (r.message == "success") {
        let { requiredCode, selectMenuCode } = r.data
        let customFormFieldRaw = toRaw(customFormField)
        if (requiredCode && requiredCode.length) {
          requiredCode.map((item) => {
            customFormFieldRaw.value[item].require = true
          })
        }
        if (selectMenuCode && selectMenuCode.length) {
          selectMenuCode.map((item) => {
            customFormFieldRaw.value[item].isHas = true
          })
        }
        customFormField = ref(customFormFieldRaw)
      } else {
        Toast.fail(r.message)
      }
    }
    getpenConfInfo()

    // 访问类型列表
    let visitorTypeList = ref([])
    const openDictionary = (params) =>
      store.dispatch("visitor/openDictionary", params)
    const getOpenDictionary = async () => {
      let params = {
        schoolCode: schoolCode.value,
      }
      let r = await openDictionary(params)
      if (r.message == "success") {
        visitorTypeList.value = r.data.list || []
      } else {
        Toast.fail(r.message)
      }
    }
    getOpenDictionary()

    const appointmentDictionaryChange = (item) => {
      form.value.appointmentDictionaryCode = item.code
      form.value.appointmentDictionaryName = item.name
      showPickerVisitorType.value = false
    }

    const showPickerVisitorType = ref(false)
    const showPickerApplicationDate = ref(false)

    const onConfirmApplicationDate = (values) => {
      let [date, h, m] = values
      form.value.applicationDate = `${date} ${h}:${m}`
      showPickerApplicationDate.value = false
    }
    const onCancleApplicationDate = () => {
      showPickerApplicationDate.value = false
    }

    const formatTimeColumns = () => {
      let dateArr = []
      for (let i = 0; i < 60; i++) {
        let curDateTime = new Date().getTime() + 24 * 60 * 60 * 1000 * i
        let curDate = Time.formatDate(new Date(curDateTime))
        dateArr.push(curDate)
      }

      let hArr = []
      for (let i = 0; i < 24; i++) {
        let h = ""
        if (i <= 9) {
          h = "0" + i
        } else {
          h = i + ""
        }
        hArr.push(h)
      }

      let mArr = []
      for (let i = 0; i < 60; i++) {
        let m = ""
        if (i <= 9) {
          m = "0" + i
        } else {
          m = i + ""
        }
        mArr.push(m)
      }

      return [
        {
          values: dateArr,
          defaultIndex: 1,
        },
        {
          values: hArr,
          defaultIndex: new Date().getHours(),
        },
        {
          values: mArr,
          defaultIndex: new Date().getMinutes(),
        },
      ]
    }
    const dateTimeColumns = reactive(formatTimeColumns())

    // 选择访问对象
    const intervieweeSelected = computed(
      () => store.state.visitor.intervieweeSelected
    )
    watch(
      intervieweeSelected,
      (newVal) => {
        let { userIndex, name, phone } = newVal
        form.value.intervieweeName = name
        form.value.intervieweeIndex = userIndex
        form.value.intervieweePhone = phone
      },
      {
        immediate: true,
      }
    )
    const showPickerIntervieweeEvt = () => {
      router.push({
        path: "/searchVisitorList",
      })
    }

    // 人脸，健康码，行程码图片
    const faceFileUpload = (fileData) => {
      let { id, url, fileList } = fileData
      form.value.faceUrl = url || ""
      form.value.faceUrlFileId = id || ""
      form.value.faceFileList = addFileBaseUrl(fileList)
    }
    const faceFileClear = () => {
      form.value.faceUrl = ""
      form.value.faceUrlFileId = ""
      form.value.faceFileList = []
    }

    const healthFileUpload = (fileData) => {
      let { id, url, fileList } = fileData
      form.value.healthCodeUrl = url || ""
      form.value.healthCodeUrlFileId = id || ""
      form.value.healthCodeFileList = addFileBaseUrl(fileList)
    }

    const travelFileUpload = (fileData) => {
      let { id, url, fileList } = fileData
      form.value.travelCodeUrl = url || ""
      form.value.travelCodeUrlFileId = id || ""
      form.value.travelCodeFileList = addFileBaseUrl(fileList)
    }

    const addFileBaseUrl = (list) => {
      list.map((item) => {
        item.url = BASE_FILE_URL + item.url
      })
      return list
    }

    const openSave = (params) => store.dispatch("visitor/openSave", params)
    const parentAppSave = (params) =>
      store.dispatch("visitor/parentAppSave", params)
    const teacherAppSave = (params) =>
      store.dispatch("visitor/teacherAppSave", params)
    const submit = async () => {
      let {
        appointmentDictionaryCode,
        applicationDate,
        personName,
        sex,
        phone,
        idNumber,
        remark,
        useSystemPhone,
        intervieweeIndex,
        intervieweePhone,
        carCode,
        peopleSum,
        faceUrl,
        faceUrlFileId,
        healthCodeUrl,
        healthCodeUrlFileId,
        travelCodeUrl,
        travelCodeUrlFileId,
      } = form.value
      // 用户自定义配置字段校验 2 人脸 3 证件信息 4 车辆信息 5 同行人数 6 来访事由 7 健康码 8 行程码
      let {
        2: faceCofig,
        4: carConfig,
        5: peopleSumConfig,
        6: remarkConfig,
        7: healthCodeConfig,
        8: travelCodeConfig,
      } = customFormField.value
      // let {
      //   2: faceCofig,
      //   3: idNumberCofig,
      //   4: carConfig,
      //   5: peopleSumConfig,
      //   6: remarkConfig,
      //   7: healthCodeConfig,
      //   8: travelCodeConfig,
      // } = customFormField.value

      // if (idNumberCofig.isHas && idNumberCofig.require) {
      //   if (!idNumber) {
      //     Toast.fail("访客身份证号不能为空！")
      //     return
      //   }
      //   if (!idCardValide(idNumber)) {
      //     Toast.fail("访客身份证号格式不正确！")
      //     return
      //   }
      // }
      if (!idNumber) {
          Toast.fail("访客身份证号不能为空！")
          return
        }
        if (!idCardValide(idNumber)) {
          Toast.fail("访客身份证号格式不正确！")
          return
        }
      if (carConfig.isHas && carConfig.require && !carCode) {
        Toast.fail("车辆信息不能为空！")
        return
      }
      if (
        peopleSumConfig.isHas &&
        peopleSumConfig.require &&
        (String(peopleSum) === "undefined" || String(peopleSum) === "null")
      ) {
        Toast.fail("同行人数不能为空！")
        return
      }
      if (remarkConfig.isHas && remarkConfig.require && !remark) {
        Toast.fail("访问事由不能为空！")
        return
      }
      if (faceCofig.isHas && faceCofig.require && !faceUrlFileId) {
        Toast.fail("人脸不能为空！")
        return
      }
      if (
        healthCodeConfig.isHas &&
        healthCodeConfig.require &&
        !healthCodeUrlFileId
      ) {
        Toast.fail("请上传健康码！")
        return
      }
      if (
        travelCodeConfig.isHas &&
        travelCodeConfig.require &&
        !travelCodeUrlFileId
      ) {
        Toast.fail("请上传行程码！")
        return
      }
      // 访问类型及预约时间校验
      if (!appointmentDictionaryCode) {
        Toast.fail("访问类型不能为空！")
        return
      }
      if (!applicationDate) {
        Toast.fail("预约时间不能为空！")
        return
      }
      // 访客信息校验
      if (!personName) {
        Toast.fail("访客姓名不能为空！")
        return
      }
      if (!phone) {
        Toast.fail("请输入访客手机号！")
        return
      }
      if (!mobileValide(phone)) {
        Toast.fail("访客手机号格式不正确！")
        return
      }

      // 拜访对象信息校验
      if (userType.value !== "teacher") {
        if (!intervieweeIndex) {
          Toast.fail("拜访对象不能为空！")
          return
        }
        if (intervieweePhone.indexOf("*") !== -1) {
          useSystemPhone = true
        } else {
          if (!intervieweePhone) {
            Toast.fail("请输入拜访对象手机号！")
            return
          }
          if (!mobileValide(intervieweePhone)) {
            Toast.fail("拜访对象手机号格式不正确！")
            return
          }
          useSystemPhone = false
        }
      }

      if (new Date().getTime() >= (new Date(`${applicationDate}:00`).getTime())) {
        Toast.fail("预约时间不能早于当前时间！")
        return
      }

      let params = {
        schoolCode: schoolCode.value,
        appointmentDictionaryCode,
        applicationDate: `${applicationDate}:00`,

        personName,
        sex,
        phone,
        idNumber,
        remark,

        intervieweeIndex,
        intervieweePhone,
        useSystemPhone, // 是否使用系统被访人手机号码
        carCode,
        peopleSum,
        faceUrl,
        faceUrlFileId,
        healthCodeUrl,
        healthCodeUrlFileId,
        travelCodeUrl,
        travelCodeUrlFileId,
      }
      let r = null
      if (plateformType.value === "webapp") {
        r = await openSave(params)
      } else {
        if (userType.value === "teacher") {
          r = await teacherAppSave(params)
        } else {
          r = await parentAppSave(params)
        }
      }
      let { success, message } = r || {}
      if (success) {
        // 重置表单数据
        store.commit("visitor/resetApplyForm")
        store.commit("visitor/setIntervieweeSelected", {})
        // 返回到首页
        router.push({
          path: "/visitorRecord",
          query: {
            schoolCode: schoolCode.value,
            plateformType: plateformType.value,
            userType: userType.value,
          },
        })
      } else {
        Toast.fail(message)
      }
    }

    return {
      schoolCode,
      themeVars,
      hasNavHeader,
      plateformType,
      userType,
      form,
      visitorTypeList,
      appointmentDictionaryChange,
      customFormField,
      showPickerVisitorType,
      showPickerApplicationDate,
      onConfirmApplicationDate,
      onCancleApplicationDate,
      dateTimeColumns,
      showPickerIntervieweeEvt,
      intervieweeSelected,
      getpenConfInfo,
      getOpenDictionary,
      openSave: (params) => store.dispatch("visitor/openSave", params),
      openChange: (params) => store.dispatch("visitor/openChange", params),
      faceFileUpload,
      faceFileClear,
      healthFileUpload,
      travelFileUpload,
      submit,
    }
  },
}
</script>

<style lang="less" scoped>
.page-frame {
  background-color: #f2f4f9;
}
.list {
  height: 2000px;
  background-color: #f00;
}
h1 {
  height: 44px;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  margin: 0;
}
.footer {
  background-color: #fff;
  text-align: center;
  .van-button {
    width: 345px;
    height: 36px;
    background: #4174fd;
    border-radius: 18px;
    margin: 6px auto;
  }
}
.visitor-type {
  border-radius: 8px 8px 0px 0px;
  background-color: #fff;
  overflow: hidden;
  .header {
    display: flex;
    height: 54px;
    align-items: center;
    padding: 0 16px;
    .left,
    .middle,
    .right {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .title {
      color: #333;
      font-size: 17px;
      font-weight: 500;
    }
    .control {
      color: #333;
      font-size: 15px;
      font-weight: 400;
      justify-content: flex-end;
    }
  }
}

.search-panel {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vw;
  z-index: 100;
}

.jy-uploader {
  height: 100%;
  display: flex;
  align-items: center;
}

/deep/ .van-field__label{
  color: #333;
}
</style>
